import PropTypes from 'prop-types';

var HeaderNavigationPropTypes = PropTypes.arrayOf(PropTypes.shape({
  /** defines link text */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  // @todo rename to "text" to be consistent with other navigation prop APIs

  /** url for the link */
  href: PropTypes.string,
  // @todo consider making optional required check if no children provided

  /** marks current active link */
  current: PropTypes.bool,

  /** custom link RouterLink, e.g. if you use ReactRouter or similar library */
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** sub navigation items, all the parameters for subnav link are the same */
  children: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    href: PropTypes.string,
    // @todo consider making optional required check if no children provided
    props: PropTypes.object,
    current: PropTypes.bool,
    RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }))
}));

export { HeaderNavigationPropTypes };
